<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      CSV Data Importer
    </portal>
    <card title="CSV Data Importer" cols="12">
      <hm-card-inner :full-size="true">
        <hm-col cols="12">
          <span class="warning-text warning-text--full-size warning-text--no-margin col-12">
            (1) Ensure that the import data <u>exactly</u> matches the specification<br />
            (2) Import Guest Profiles <u>first</u>, to prevent duplicates<br />
            (3) Ensure each row has a <u>unique</u> ID field, to allow for updates in case the import data wasn't correct<br />
            (4) Check all inputs <u>twice</u> before hitting submit (once started an import can <u>not</u> be stopped.
          </span>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner>
        <hm-input v-model="systemKey" name="systemKey" cols="start-1 12 6@desktop" label="Bezeichnung" />
        <hm-input-select v-model="type"
                         name="type"
                         cols="start-1 12 6@desktop"
                         label="Typ"
                         enum-name="ImportType" />
        <hm-input-select v-model="separator" name="separator" cols="start-1 12 6@desktop" label="Value Separator">
          <option value=",">,</option>
          <option value=";">;</option>
        </hm-input-select>
        <hm-input-file ref="file"
                       :url="''"
                       v-model="file"
                       label="CSV File"
                       cols="start-1 12 6@desktop" />
      </hm-card-inner>
    </card>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :disabled="!canImport"
                          label="Import"
                          icon="upload"
                          color="orange"
                          @click="importCsv" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, groupBy, isEmpty, isNil, keyBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmFloatingButton from '../../lib/inputs/HmFloatingButton';
import HmCardInner from '../../lib/layout/HmCardInner';
import HmMultiselect from '../../lib/inputs/HmMultiselect';
import HmInputNumber from '../../lib/inputs/HmInputNumber.vue';
import HmInputMoney from '../../lib/inputs/HmInputMoney.vue';
import HmInputTimeOfDaySlider from '../../lib/inputs/HmInputTimeOfDaySlider.vue';
import TabableCard from '../../lib/layout/TabableCard.vue';
import TabableCardContent from '../../lib/layout/TabableCardContent.vue';
import HmTextarea from '../../lib/inputs/HmTextarea.vue';
import HmInputToggle from '../../lib/inputs/HmInputToggle.vue';
import HmInputSelect from '../../lib/inputs/HmInputSelect.vue';
import HmInputFile from '../../lib/inputs/HmInputFile.vue';

export default {
  name: 'PageImport',
  components: { HmInputFile, HmInputSelect, HmInputToggle, HmTextarea, TabableCardContent, TabableCard, HmInputTimeOfDaySlider, HmInputMoney, HmInputNumber, HmMultiselect, HmCardInner, HmFloatingButton },

  mixins: [HotelmeisterMixin],

  data() {
    return {
      systemKey: 'Import',
      type: 'GuestProfile',
      separator: ',',
      file: { fileName: null, fileURL: null, file: null },
    };
  },

  computed: {
    canImport: function () {
      if (isEmpty(this.systemKey)) return false;
      if (isEmpty(this.type)) return false;
      if (isEmpty(this.separator)) return false;
      if (isNil(this.file.file)) return false;

      return true;
    },
  },

  watch: {
  },

  created: function () {
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    importCsv() {
      if (!this.canImport) return;

      const formData = new FormData();
      formData.append('systemKey', this.systemKey);
      formData.append('type', this.type);
      formData.append('separator', this.separator);
      formData.append('file', this.file.file);

      this.axios.post(this.serviceUrls.import.import(this),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          this.showSuccessMessage();
          this.systemKey = 'Import';
          this.type = 'GuestProfile';
          this.separator = ',';
          this.file = { fileName: null, fileURL: null, file: null };
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageImport.vue